export function Loader() {
	return (
		<div id="loader">
			<div className="lds-heart"><div></div></div>
		</div>
	);
}